import axios from './axios-auth'

const getProducts = (categoryId, offset, limit, searchFilter, sort, cancelToken, pointFilter = "") =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
      category: categoryId,
      search: searchFilter,
      sort: sort,
      pointFilter:pointFilter
    }
    axios({
      url: '/product',
      method: 'GET',
      params: params,
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getHotProducts = (offset, limit, cancelToken) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
    }
    axios({
      url: '/product/whatshot',
      method: 'GET',
      params: params,
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getBonusPointProducts = (offset, limit, cancelToken) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
    }
    axios({
      url: '/product/bonusPoints',
      method: 'GET',
      params: params,
      cancelToken: cancelToken
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getProduct = (categoryId, productId) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/product/${categoryId}/${productId}`,
      method: 'GET'
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

const getBonusPointsProduct = (productId) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/product/bonusPoints/' + productId,
      method: 'GET'
    })
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export { getProducts, getHotProducts, getProduct, getBonusPointProducts, getBonusPointsProduct }
